import { Injectable } from '@angular/core';
import * as Models from '../../models/utils/country-language.interfaces';
import { CountryLanguageHelpExtension } from './country-language-help-extension';
@Injectable({
  providedIn: 'root'
})
export class CountryLanguageHelperExtended extends CountryLanguageHelpExtension {
  getPrimaryLanguage(countryCode: string): Models.LanguageDetails | null {
    if (this.countryLanguageList) {
      countryCode = countryCode.toLowerCase();
      const languageList = this.getCountryForCountryCode(countryCode);
      if (languageList) {
        const prefLanguage = languageList.languageDtls.filter((item) => {
          return item.prefLanguage === 'Y';
        });
        if (prefLanguage.length > 0) {
          return prefLanguage[0];
        }
      }
    }
    return null;
  }

  getSecondaryLanguage(countryCode: string): string | null {
    if (this.countryLanguageList) {
      countryCode = countryCode.toLowerCase();
      const languageList = this.countryLanguageList.filter((item) => {
        return item.isoCode.toLowerCase() === countryCode;
      });
      if (languageList.length > 0) {
        const secondaryPrefLanguage = languageList[0].languageDtls.filter(
          (item) => {
            if (item.secondaryPrefLanguage) {
              return item.secondaryPrefLanguage === 'Y';
            }
            return null;
          }
        );
        if (secondaryPrefLanguage.length > 0) {
          return secondaryPrefLanguage[0].languageCode;
        }
      }
    }
    return null;
  }

  getSecondaryLanguageForSelectedLanguage(
    countryCode: string,
    primaryLanguage: string
  ): Models.LanguageDetails | null {
    if (this.countryLanguageList) {
      countryCode = countryCode.toLowerCase();
      primaryLanguage = primaryLanguage?.toLowerCase();
      const languageList = this.countryLanguageList.filter((item) => {
        return item.isoCode.toLowerCase() === countryCode;
      });
      if (languageList.length > 0) {
        const secondaryPrefLanguage = languageList[0].languageDtls.filter(
          (item) => {
            return (
              item.languageCode.toLowerCase() !== primaryLanguage &&
              ((item.secondaryPrefLanguage
                ? item.secondaryPrefLanguage === 'Y'
                : false) ||
                item.prefLanguage === 'Y')
            );
          }
        );
        if (secondaryPrefLanguage?.length > 0) {
          return secondaryPrefLanguage[0];
        }
      }
    }
    return null;
  }

  getTranslatedTextForLanguageCode(
    languageCode: string | undefined,
    textKey: string
  ): string | null {
    if (this.translatedText && languageCode) {
      languageCode = languageCode.toLowerCase();
      const translatedMsg =
        this.translatedText[languageCode as keyof Models.TranslatedText];
      if (translatedMsg) {
        return translatedMsg[textKey as keyof Models.TranslatedLang];
      }
    }
    return null;
  }

  setData(countryLanguageData: Models.CountryLanguageDetails): void {
    this.countryLanguageList = countryLanguageData['countryLanguages'];
    this.regionList = countryLanguageData['regionlist'];
    this.translatedText = countryLanguageData['translated-text'];
    this.redirectionList = countryLanguageData['redirectionUrl'];
  }

  getRegionList(): Models.RegionList[] {
    return this.regionList;
  }

  getTranslatedTextList(): Models.TranslatedText {
    return this.translatedText;
  }

  deleteCookie(prefUI: string): void {
    const date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    document.cookie =
      'prefUI' +
      '=; expires=' +
      date.toUTCString() +
      ';domain=.delta.com; path=/';
    const cookiesLife = new Date();
    cookiesLife.setTime(cookiesLife.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires = '; expires=' + cookiesLife.toUTCString();
    const cookieDomain = ';domain=.delta.com; path=/';
    const cookieDetails = prefUI + '=' + 'en-us' + expires + cookieDomain;
    document.cookie = cookieDetails;
  }

  finalActionUrl(
    actionUrl: string,
    languageCode: string,
    countryCode: string,
    returnCode: string,
    currentPage: string
  ): string {
    let startIndex = currentPage.indexOf('.com/') + 4;
    if (this.reqdLanguage?.length > 0) {
      actionUrl = this.checkLangListForActionUrl();
    }
    startIndex += 2 + countryCode.length + languageCode.length;
    if (startIndex > 3) {
      actionUrl = this.getActionUrl(
        returnCode,
        currentPage,
        actionUrl,
        startIndex
      );
    }
    return actionUrl;
  }
}
